export const events = {
  'youth-bootcamp': {
    id: 'youth-bootcamp',
    title: 'Summer Boot Camp',
    subtitle: 'Armed and Ready for the Kingdom',
    tagline: 'Combining Faith and FUN',
    dates: '11-13 JULY 2025',
    location: '221 N. DOOLEY ST, GRAPEVINE TX 76051',
    eventDate: 'July 11, 2025 00:00:00',
    priority: 3,
    poster: 'youth-bootCamp-poster.jpg',
    images: {
      hero: 'youth-bootcamp/justPhoto.jpg',
      gallery: [
        'youth-bootcamp/preview-event-1.jpg',
        'youth-bootcamp/preview-event-2.jpg',
        'youth-bootcamp/preview-event-3.jpg',
        'youth-bootcamp/preview-event-4.jpg',
        'youth-bootcamp/preview-event-5.jpg'
      ],
      whatToBring: 'whatToBring.jpg'
    },
    theme: {
      primary: '#ffc107',
      secondary: '#212529'
    }
  },
  'women-of-noble-character': {
    id: 'women-of-noble-character',
    title: 'Women of Noble Character',
    subtitle: 'Annual Conference',
    tagline: 'Rebuild on New Foundations',
    dates: '29-30 MAY 2026',
    location: '221 N Dooley Street, Grapevine, TX 76051',
    eventDate: 'May 29, 2026 00:00:00',
    priority: 1,
    poster: 'women-of-noble-character/women-conference-save-date.jpg',
    images: {
      hero: 'women-of-noble-character/wnc.jpg',
      gallery: [
        'women-of-noble-character/wnc-7059.jpg',
        'women-of-noble-character/wnc-7061.jpg',
        'women-of-noble-character/wnc-7064.jpg',
        'women-of-noble-character/wnc-7066.jpg',
        'women-of-noble-character/wnc-7067.jpg',
        'women-of-noble-character/wnc-7068.jpg',
        'women-of-noble-character/wnc-7070.jpg',
        'women-of-noble-character/wnc-7072.jpg',
        'women-of-noble-character/wnc-7073.jpg',
        'women-of-noble-character/wnc-7074.jpg',
        'women-of-noble-character/wnc2.jpg'
      ],
      whatToBring: null
    },
    schedule: {
      friday: 'Friday May 29, 2026',
      saturday: 'Saturday May 30, 2026'
    },
    host: 'Servante Namish Mpeti',
    guest: 'Prophetess Bola Sarah Adedimeji',
    contact: 'info@jesuslebonberger.org',
    theme: {
      primary: '#d63384',
      secondary: '#6f42c1'
    }
  },
  'couples-conference': {
    id: 'couples-conference',
    title: 'Couples Conference 2025',
    subtitle: 'Couples Conference 2025',
    tagline: 'Christian Marriage in the Face of Modern Western Challenges',
    dates: '20-21 SEPTEMBER 2025',
    location: '221 N Dooley Street, Grapevine, TX 76051',
    eventDate: 'September 20, 2025 17:00:00',
    priority: 2,
    poster: 'couples-conference/couples-conference-poster.jpg',
    images: {
      hero: 'couples-conference/couples-conference-poster.jpg',
      gallery: [],
      whatToBring: null
    },
    schedule: {
      saturday: 'Saturday September 20, 2025 @ 5:00 PM',
      sunday: 'Sunday September 21, 2025 @ 3:00 PM'
    },
    host: 'Br. Boniface KAYEMBE',
    guest: 'Past. Donatien BADIBANGA',
    contact: 'info@jesuslebonberger.org',
    theme: {
      primary: '#e91e63',
      secondary: '#9c27b0'
    }
  },
  'youth-conference': {
    id: 'youth-conference',
    title: 'Annual Youth Conference',
    subtitle: 'Annual Youth Conference',
    tagline: 'Jesus-Christ: Can He Count On You?',
    dates: '21-22 NOVEMBER 2026',
    location: '221 N Dooley Street, Grapevine, TX 76051',
    eventDate: 'November 21, 2026 16:00:00',
    priority: 0,
    images: {
      hero: 'youth-conference/youth-conference-poster.jpeg',
      gallery: [],
      whatToBring: null
    },
    schedule: {
      saturday: 'Saturday November 21, 2026 @ 4:00 PM',
      sunday: 'Sunday November 22, 2026 @ 3:30 PM'
    },
    host: 'Serv. Joseph B Zener',
    guest: 'Prophet Jonathan Noble & Apostle Paul Kandu',
    contact: 'info@jesuslebonberger.org',
    theme: {
      primary: '#1565c0',
      secondary: '#0d47a1'
    }
  },
};

export const getEvent = (eventId) => events[eventId];
export const getAllEvents = () => Object.values(events);